<ng-container *transloco="let t">
  <div class="owner-statement-new-passport">
    <div [formGroup]="form">
      <h3 class="mb-2">
        {{ t('Owner Statement Regarding Issuance of New Passport') }}
      </h3>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Current passport status') }}</mat-label>
        <mat-select formControlName="currentPassportStatus">
          <mat-option [value]="t('Passport - Lost')">{{
            t('Passport - Lost')
          }}</mat-option>
          <mat-option [value]="t('Passport - Damaged')">{{
            t('Passport - Damaged')
          }}</mat-option>
          <mat-option [value]="t('Passport - Other')">{{
            t('Passport - Other')
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Note') }}</mat-label>
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
